export default "__VITE_ASSET__efd1809c__"